export default __webpack_public_path__ + "final.mp4";